import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import NewsDetail from "@/views/NewsDetail.vue";
import SolutionDetail from "@/views/SolutionDetail.vue";
import NewsMore from "@/views/NewsMore.vue";
import Login from "@/views/Login.vue";
import AdminManage from "@/views/AdminManage.vue";

const routes = [

  {
    path: '/news-detail',
    name: 'newsDetail',
    component: NewsDetail,
    meta: {
      title: '新闻详情'
    },
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      title: '登录页面'
    },
  },
  {
    path: '/solution-detail',
    name: 'solutionDetail',
    component: SolutionDetail,
    meta: {
      title: '解决方案详情'
    },
  },
  {
    path: '/news-more',
    name: 'newsMore',
    component: NewsMore,
    meta: {
      title: '更多新闻'
    },
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/center',
    name: 'center',
    component: AdminManage,
    meta: {
      title: '个人中心'
    },
  },
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: '首页'
    },
  },

]

const router = createRouter({
  model: 'hash',
  history: createWebHistory(process.env.BASE_URL),
  routes
})
const title = "中南经纬环境研究院";//可以在这里直接定义，也可以在一个地方统一设置再在这里引入

function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`;
  }
  return `${title}`;
}
router.beforeEach(async (to, from, next) => {
  document.title = getPageTitle(to.meta.title);
  next();
});

export default router
